module.exports = __webpack_public_path__ + "a08f54c9d55b32c0578a81f090a78dc2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/new-year-sale-banner.png
// module id = 1049
// module chunks = 0